import { Currency } from "@elton/types";

export const BarColorByCurrency: Record<Currency, string> = {
  NOK: "#008A7A",
  SEK: "#9DD3CB",
  DKK: "#F58342",
  EUR: "#58B2CE",
};
